import {
	SET_ATTENDEES,
	CLEAR_ATTENDEES,
	CREATE_ATTENDEE,
	UPDATE_ATTENDEE,
	DELETE_ATTENDEE,
	REMOVE_MANY_ATTENDEES_FROM_EVENT,
} from '../actions/actionTypes';
import { arrToObj } from '@/redux/util';

const preState = {};

const attendeesReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, attendees, attendee, attendeeIDs, deleteAttendeeID } = action;
	switch (type) {
		case SET_ATTENDEES:
			return arrToObj(attendees.nodes);
		case CLEAR_ATTENDEES:
			return {};
		case CREATE_ATTENDEE:
			const attendeeID = attendee.id;
			const newAttendee = { ...attendee };
			return { ...stateDup, [attendeeID]: newAttendee };
		case UPDATE_ATTENDEE:
			return stateDup;
		case DELETE_ATTENDEE:
			delete stateDup[deleteAttendeeID];
			return stateDup;
		case REMOVE_MANY_ATTENDEES_FROM_EVENT:
			delete stateDup[attendeeIDs];
			return stateDup;
		default:
			return stateDup;
	}
};

export default attendeesReducer;
